import app from "../data/base";

const requestOptions = {
  method: 'GET',
  redirect: 'follow',
};

const getTranscription = async (link) => {
  try {
    const response = await fetch(link, requestOptions);
    console.log(response)
    return await response.text();

  } catch (err) {
    console.log(`Errore nel recuperare ${link}`);
    console.error(err);
    throw err;
  }
}

export const transcription = {
  methods: {
    getTranscription
  }
}
